// Margine UNICO dell'app: (prezzo di vendita − costi diretti − costi indiretti) / prezzo di vendita.
// Costi indiretti = costi fissi globali (Impostazioni) + provvigione venditore.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const RICARICO_STIMA = 1.8; // costo stimato = prezzo / 1.8 quando manca il prezzo d'acquisto

export const canSeeMarginDetails = (user) =>
  (user?.role || "").toLowerCase() === "admin" || (user?.venditore_level || "").toLowerCase() === "area_manager";

export const costoStimato = (prezzoVendita) => (Number(prezzoVendita) || 0) / RICARICO_STIMA;

export function useMarginParams(ruolo = "semplice") {
  const [params, setParams] = useState(null);
  useEffect(() => {
    let off = false;
    api.post("/marginalita/calcola", { totale_iva_escl: 100, costi_diretti: 0, ruolo_venditore: ruolo })
      .then(({ data }) => {
        if (off) return;
        const cf = data.costi_fissi_breakdown || [];
        setParams({
          fissi: cf.map((c) => ({ nome: c.nome, tipo: c.tipo, valore: Number(c.valore_config) || 0 })),
          provPct: Number(data.provvigione_venditore_pct) || 0,
          soglia: Number(data.soglia_margine_minimo) || 30,
        });
      })
      .catch(() => { if (!off) setParams({ fissi: [], provPct: 3, soglia: 30 }); });
    return () => { off = true; };
  }, [ruolo]);
  return params;
}

export function calcMargine(ricavo, costiDiretti, p) {
  const R = Number(ricavo) || 0;
  if (!p || R <= 0) return null;
  const fissi = p.fissi.map((c) => ({ nome: c.nome, importo: c.tipo === "percentuale" ? (R * c.valore) / 100 : c.valore, label: c.tipo === "percentuale" ? `${c.valore}%` : "" }));
  const indiretti = fissi.reduce((s, c) => s + c.importo, 0);
  const provvigione = (R * p.provPct) / 100;
  const utile = R - (Number(costiDiretti) || 0) - indiretti - provvigione;
  const pct = (utile / R) * 100;
  const giudizio = pct < p.soglia ? "basso" : pct < p.soglia + 5 ? "attenzione" : "buono";
  return { ricavo: R, costiDiretti: Number(costiDiretti) || 0, fissi, indiretti, provvigione, provPct: p.provPct, utile, pct, soglia: p.soglia, giudizio };
}
